import { Component } from '@angular/core';
import { CommonService } from '../../../Model/Common/common.service';
import { MusterAttendanceService } from '../../../Model/MusterAttendance/muster-attendance.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbDatepickerModule, NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { ApprovalMatrixFormFilterComponent } from '../../../Setting/ApprovalMatrixFormFilter/approval-matrix-form-filter/approval-matrix-form-filter.component';
import { Subject } from 'rxjs';
import { DataTablesModule } from 'angular-datatables';
import { EmployeeSiteMapingService } from '../../../Model/EmployeeSiteMaping/employee-site-maping.service';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-employee-multisite',
  standalone: true,
  imports: [CommonModule, FormsModule, DataTablesModule, NgbDatepickerModule, NgbDropdownModule, NgSelectModule, LoaderComponent],
  templateUrl: './employee-multisite.component.html',
  styleUrl: './employee-multisite.component.scss'
})
export class EmployeeMultisiteComponent {
  isDisabled: boolean = false;
  Branchs = [] as any;
  Clients = [] as any;
  Sites = [] as any;
  Employees = [] as any
  Designations = [] as any
  dtTrigger: Subject<any> = new Subject<any>();

  Filter = {
    IsSubContractor: false,
    BranchID: null,
    ClientID: null,
    SiteID: null,
  }

  SaveDetails = {
    SelectType: 'i',
    SiteId: null,
    ESS_EmployeeSiteMapping: [] as any,
    EmpType: null as any,
  }

  dtOptions: DataTables.Settings = {
    pagingType: 'full_numbers',
    searching: false,
    paging: false,
    pageLength: 10,
    info: false,
    lengthMenu: [10, 25, 50, 100],
    ordering: false,
    language: {
      searchPlaceholder: 'Search...',
    },
    stateSave: true,
    processing: false,
    order: [[0, 'asc']],
    columnDefs: [],
    drawCallback: () => {
      this.bindSelectAllCheckbox();
    },
    rowCallback: (row: Node, data: any, index: number) => {
      // Ensure checkbox state is set after row is created
      const checkbox = $(row).find('.row-checkbox');
      if (checkbox.length) {
        checkbox.prop('checked', data.IsChecked || false);
      }
      return row;
    },
    columns: [],
  };

  IsReset = false;

  constructor(
    protected common: CommonService,
    private combo: ComboService,
    private modalService: NgbModal,
    private employeesitemaping: EmployeeSiteMapingService,
    private toast: ToastService,
    private route: ActivatedRoute,
  ) {
    this.common.getPageRights();
    this.route.params.subscribe(params => this.Filter.IsSubContractor = params['type'] == 'subemp');
  }

  ngOnInit() {
    this.ComboLoad('Branch');
    if (this.Filter.IsSubContractor) {
      this.SaveDetails.EmpType = 'SubContractor';
    } else {
      this.SaveDetails.EmpType = 'Front';
    }
    if (this.Filter.IsSubContractor) {
      this.dtOptions.columnDefs?.push(
        {
          targets: 0,
          width: '5px',
        },
        {
          targets: 1,
          width: '10px',
        },
        {
          targets: 3,
          width: '150px',
        },
        {
          targets: 4,
          width: '100px',
        },
        {
          targets: 5,
          width: '100px',
        },
        {
          targets: 6,
          width: '100px',
        },
      )

    } else {
      this.dtOptions.columnDefs?.push(
        {
          targets: 0,
          width: '5px',
        },
        {
          targets: 1,
          width: '10px',
        },
        {
          targets: 3,
          width: '100px',
        },
        {
          targets: 4,
          width: '100px',
        },
        {
          targets: 5,
          width: '100px',
        },
      );
    }
  }

  ngOnDestroy(): void {
    if ($.fn.dataTable.isDataTable('#employeedata')) {
      $('#employeedata').DataTable().destroy();
    }
    this.dtTrigger.unsubscribe();
  }

  async FilterValidate(form: any, IsSearch: boolean) {
    if (form.valid) {
      if (IsSearch) {
        this.IsReset = true;
        this.ESS_EmployeeSiteMappingSelect();
      }
    }
    else {
      if (!IsSearch) {
        if (this.common.PageRight.IsAdd) {
          this.FilterForm();
        }
      }
      form.submitted = true;
    }
  }

  async ComboLoad(Combotype: String, index = -1, refresh = false, isClear = true): Promise<any> {
    if (Combotype == 'Branch') {
      this.Branchs = [];
      this.Clients = [];
      this.Sites = [];

      this.Filter.BranchID = null;
      this.Filter.ClientID = null;
      this.Filter.SiteID = null;
    } else if (Combotype == 'Client') {
      this.Clients = [];
      this.Sites = [];

      this.Filter.ClientID = null;
      this.Filter.SiteID = null;
    } else if (Combotype == 'Site') {
      this.Sites = [];

      this.Filter.SiteID = null;
    } else if (Combotype == 'Designation') {
      this.Designations = [];
    } else if (Combotype == 'Duty' && index >= 0) {
      this.Employees[index].Dutys = [];
      this.Employees[index].Shifts = [];

      if (isClear) {
        this.Employees[index].DutyID = null;
        this.Employees[index].ShiftID = null;
      }
    } else if (Combotype == 'ShiftLoadBasedOnDesignationDuty' && index >= 0) {
      this.Employees[index].Shifts = [];
      if (isClear) {
        this.Employees[index].ShiftID = null;
      }
    }

    this.isDisabled = true;
    return new Promise((resolve, reject) => {
      this.combo.ComboLoad({
        'Combotype': Combotype,
        'BranchId': (Combotype == 'Designation' || Combotype == 'Duty' || Combotype == 'ShiftLoadBasedOnDesignationDuty' || Combotype == 'Client' || Combotype == 'Site') ? this.Filter.BranchID : 0,
        'ClientId': (Combotype == 'Designation' || Combotype == 'Duty' || Combotype == 'ShiftLoadBasedOnDesignationDuty' || Combotype == 'Client' || Combotype == 'Site') ? this.Filter.ClientID : 0,
        'SiteId': (Combotype == 'Designation' || Combotype == 'Duty' || Combotype == 'ShiftLoadBasedOnDesignationDuty') ? this.Filter.SiteID : 0,
        'DesignationId': ((Combotype == 'Duty' || Combotype == 'ShiftLoadBasedOnDesignationDuty') && index >= 0) ? this.Employees[index].DesignationID : 0,
        'DutyId': ((Combotype == 'ShiftLoadBasedOnDesignationDuty') && index >= 0) ? this.Employees[index].DutyID : 0,
        'EmpType': 'Front',
      }).subscribe({
        next: (response) => {
          if (Combotype == 'Branch') {
            if (response.ComboLoad) {
              this.Branchs = response.ComboLoad;
            }
          } else if (Combotype == 'Client') {
            if (response.ComboLoad) {
              this.Clients = response.ComboLoad;
            }
          }
          else if (Combotype == 'Site') {
            if (response.ComboLoad) {
              this.Sites = response.ComboLoad;
            }
          } else if (Combotype == 'Designation') {
            if (response.ComboLoad) {
              this.Designations = response.ComboLoad;
            }
          } else if (Combotype == 'Duty' && index >= 0) {
            if (response.ComboLoad) {
              this.Employees[index].Dutys = response.ComboLoad;
            }
          } else if (Combotype === 'ShiftLoadBasedOnDesignationDuty' && index >= 0) {
            if (response.ComboLoad) {
              this.Employees[index].Shifts = response.ComboLoad;
            }
          }

          if (refresh) {
            this.initializeDataTable('#employeedata', Object.values(this.Employees));
          }
          this.isDisabled = false;
          resolve(true); // Resolve after data is loaded
        },
        complete: () => {
          this.isDisabled = false;
        },
        error: (error) => {
          this.isDisabled = false;
          reject(error);
        },
      });
    });
  }

  FilterForm() {
    const modalRef = this.modalService.open(ApprovalMatrixFormFilterComponent, { size: 'lg' });
    modalRef.componentInstance.Title = 'Employee';
    modalRef.componentInstance.WebESSApplicabilityId = 8;
    modalRef.componentInstance.EmpType = 'Front';
    modalRef.componentInstance.IsSubContractor = this.Filter.IsSubContractor;
    modalRef.componentInstance.ShowFilter = {
      ShowSearchEmployee: true,
    }
    modalRef.result.then(result => {
      if (result != undefined && result != null && result != '') {
        result.forEach((element: any) => {
          const index = this.Employees.findIndex((e: any) => e.EmployeeID == element.EmpMasterID)
          if (index < 0) {
            if (this.Filter.IsSubContractor) {
              if (element.Count >= 0) {
                this.Employees.push({
                  EmployeeID: element.EmpMasterID,
                  EmpCode: element.EmpCode,
                  FullName: element.FullName,
                  Photo: null,
                  IsChecked: false,
                  DesignationID: null,
                  DutyID: null,
                  ShiftID: null,
                  Dutys: [],
                  Shifts: [],
                  VendorId: element.VendorId,
                  VendorCode: element.VendorCode,
                  VendorName: element.VendorName,
                });
              } else {
                this.Employees.push({
                  EmployeeID: element.EmpMasterID,
                  EmpCode: element.EmpCode,
                  FullName: element.FullName.split(' - ')[1],
                  Photo: element.Photo,
                  IsChecked: false,
                  DesignationID: null,
                  DutyID: null,
                  ShiftID: null,
                  Dutys: [],
                  Shifts: [],
                  VendorId: element.VendorId,
                  VendorCode: element.VendorCode,
                  VendorName: element.VendorName,
                });
              }
            } else {
              if (element.Count >= 0) {
                this.Employees.push({
                  EmployeeID: element.EmpMasterID,
                  EmpCode: element.EmpCode,
                  FullName: element.FullName,
                  Photo: null,
                  IsChecked: false,
                  DesignationID: null,
                  DutyID: null,
                  ShiftID: null,
                  Dutys: [],
                  Shifts: [],
                });
              } else {
                this.Employees.push({
                  EmployeeID: element.EmpMasterID,
                  EmpCode: element.EmpCode,
                  FullName: element.FullName.split(' - ')[1],
                  Photo: element.Photo,
                  IsChecked: false,
                  DesignationID: null,
                  DutyID: null,
                  ShiftID: null,
                  Dutys: [],
                  Shifts: [],
                });
              }
            }
          }else{
            this.toast.show({message:'Employee already exists ' + this.Employees[index].EmpCode.toString() + '-' +  this.Employees[index].FullName.toString(),type:toastTypeEnum.warning});
          }
        });
        this.initializeDataTable('#employeedata', Object.values(this.Employees));
      }
    });
  }

  initializeDataTable(selector: string, data: any[]) {
    const tableElement = $(selector);

    const scrollTop = $('.p-3.col.childclass').scrollTop();
    const scrollLeft = $('.p-3.col.childclass').scrollLeft();


    if ($.fn.dataTable.isDataTable(selector)) {
      $(selector).DataTable().destroy();
      $(selector).empty();
    }

    this.dtOptions.columns = this.getColumns();
    this.dtOptions.createdRow = (row: Node, data: any, index: number) => {
      const $checkbox = $(row).find('.row-checkbox');

      $checkbox.prop('checked', data.selected ?? false);

      $checkbox.off('change').on('change', (event: any) => {
        const isChecked = event.target.checked;
        data.selected = isChecked;
        this.Employees[index].IsChecked = isChecked;
      });
    }

    const table = $(selector).DataTable({
      data: data,
      ...this.dtOptions
    });

    const restoreScroll = () => {
      $('.p-3.col.childclass').scrollTop(scrollTop??0);
      $('.p-3.col.childclass').scrollLeft(scrollLeft??0);
    };

    table.on('draw.dt', restoreScroll);
    setTimeout(restoreScroll, 0);
    setTimeout(restoreScroll, 100);
    setTimeout(restoreScroll, 300);
  }

  bindSelectAllCheckbox() {
    $('#selectAllCheckbox').off('change').on('change', (e: any) => {
      const checked = e.target.checked;
      $('.row-checkbox').prop('checked', checked);
      this.selectAll(checked);
    });
  }

  selectAll(checked: boolean) {
    this.Employees.map((e: any) => e.IsChecked = checked);
  }

  getColumns(): any[] {
    const columns: any[] = [];
    columns.push(
      {
        title: '#',
        data: null,
        render: (data: any, type: any, row: any, meta: any) => {
          return `<strong>${meta.row + (meta.settings.displayStart ?? 0) + 1}</strong>`;
        },
        orderable: true,
      },
    );

    columns.push(
      {
        title: `<input type="checkbox" id="selectAllCheckbox">`,
        data: null,
        orderable: false,
        render: (data: any, type: any, row: any, meta: any) => {
          console.log(row.IsChecked);
          const isChecked = row.IsChecked ? 'checked' : '';
          return `<input type="checkbox" class="row-checkbox" data-row-index="${meta.row}" ${isChecked}>`;
        },
      },
      {
        title: 'Detail',
        data: null,
        render: (data: any, type: any, row: any, meta: any) => {
          let profileImage = '';
          if (row.Photo) {
            profileImage = `
              <img class="userImage" 
                  style="width: 40px;height: 40px;"
                   src="${this.common.PhotoLink(row.Photo)}" 
                   data-row='${JSON.stringify(row).replace(/'/g, "\\'")}'
                   data-is-profile="true" />
            `;
          } else {
            profileImage = `
              <div class="initial-image" 
                  style="width: 40px;height: 40px;"
                   data-row='${JSON.stringify(row).replace(/'/g, "\\'")}'
                   data-is-profile="true">
                <div class="image">${this.common.getInitial(row.FullName)}</div>
              </div>
            `;
          }
          // Return the complete structure
          return `
            <div class="row no-gutters cursor-pointer" style="align-items: center; width: 230px;">
              <div class="col-3">
                ${profileImage}
              </div>
              <div class="col-9 userdetail p-0">
                <span class="text-label" >${row.FullName || ''}</span><br />
                <span class="text-label-light">#${row.EmpCode || ''}</span>
              </div>
            </div>
          `;
        },
        orderable: true,
      },
    );
    if (this.Filter.IsSubContractor) {
      columns.push(
        {
          title: 'Vendor',
          data: null,
          render: (data: any, type: any, row: any, meta: any) => {
            return row.VendorCode + '-' + row.VendorName;
          },
          orderable: false,
          createdCell: (td: any, cellData: any, rowData: any, rowIndex: any, colIndex: any) => { }
        });
    }
    columns.push(
      {
        title: 'Designation',
        data: null,
        render: (data: any, type: any, row: any, meta: any) => {
          const selectId = `designations-${meta.row}`;

          const options = (this.Designations ?? []).map((type: any) =>
            `<option value=${type.DesignationMasterID} ${row.DesignationID === type.DesignationMasterID ? 'selected' : ''}>
              ${type.DesignationName}
            </option>`
          ).join('');

          const isSelected = row.DesignationID ? '' : 'selected';

          return `
            <select class="form-select" name="designations-${meta.row}" id="${selectId}" style="font-size:xx-small">
              <option value=null ${isSelected}>--select--</option>
              ${options}
            </select>
          `;
        },
        orderable: false,
        createdCell: (td: any, cellData: any, rowData: any, rowIndex: any, colIndex: any) => {
          $(td).find('select').on('change', async (e) => {
            rowData.DesignationID = parseInt(e.target.value) || 0;
            await this.ComboLoad("Duty", rowIndex, true);
            this.Employees[rowIndex].DesignationID = parseInt(e.target.value) || 0;
          });
        }
      },
      {
        title: 'Duty',
        data: null,
        render: (data: any, type: any, row: any, meta: any) => {
          const selectId = `dutys-${meta.row}`;
          const options = (row.Dutys ?? []).map((type: any) =>
            `<option value=${type.DutyMasterID} ${row.DutyID === type.DutyMasterID ? 'selected' : ''}>
              ${type.DutyName}
            </option>`
          ).join('');

          const isSelected = row.DutyID ? '' : 'selected';

          return `
            <select class="form-select" name="dutys-${meta.row}" id="${selectId}" style="font-size:xx-small">
              <option value=null ${isSelected}>--select--</option>
              ${options}
            </select>
          `;
        },
        orderable: false,
        createdCell: (td: any, cellData: any, rowData: any, rowIndex: any, colIndex: any) => {
          $(td).find('select').on('change', async (e) => {
            rowData.DutyID = parseInt(e.target.value) || 0;
            await this.ComboLoad("ShiftLoadBasedOnDesignationDuty", rowIndex, true);
            this.Employees[rowIndex].DutyID = parseInt(e.target.value) || 0;
          });
        },
      },
      {
        title: 'Shift',
        data: null,
        render: (data: any, type: any, row: any, meta: any) => {
          const selectId = `shifts-${meta.row}`;

          const options = (row.Shifts ?? []).map((type: any) =>
            `<option value=${type.ShiftMasterID} ${row.ShiftID === type.ShiftMasterID ? 'selected' : ''}>
                ${type.ShiftTitle}
              </option>`
          ).join('');

          const isSelected = row.ShiftID ? '' : 'selected';

          return `
              <select class="form-select" name="shifts-${meta.row}" id="${selectId}" style="font-size:xx-small">
                <option value=null ${isSelected}>--select--</option>
                ${options}
              </select>
            `;
        },
        orderable: false,
        createdCell: (td: any, cellData: any, rowData: any, rowIndex: any, colIndex: any) => {
          $(td).find('select').on('change', (e) => {
            rowData.ShiftID = parseInt(e.target.value) || 0;
            this.Employees[rowIndex].ShiftID = parseInt(e.target.value) || 0;
          });
        }
      },
    );
    return columns;
  }

  ESS_EmployeeSiteMapping_InsertUpdate() {
    if (this.common.PageRight.IsEdit) {
      if (this.Employees.filter((e: any) => e.IsChecked).length > 0) {
        if (this.Employees.filter((e: any) => e.IsChecked).findIndex((e: any) => e.DesignationID == 0 || e.DesignationID == null || e.DesignationID == '' || e.DutyID == 0 || e.DutyID == null || e.DutyID == '' || e.ShiftID == 0 || e.ShiftID == null || e.ShiftID == '') < 0) {
          const modalRef = this.modalService.open(ConfirmationComponent);
          modalRef.componentInstance.Message = 'Do you want to update?';
          modalRef.result.then(result => {
            if (result) {
              this.isDisabled = true;
              this.SaveDetails.SiteId = this.Filter.SiteID;
              this.SaveDetails.ESS_EmployeeSiteMapping = [];
              this.Employees.filter((e: any) => e.IsChecked).forEach((element: any) => {
                this.SaveDetails.ESS_EmployeeSiteMapping.push(
                  {
                    EmpMasterId: element.EmployeeID,
                    DesignationId: element.DesignationID,
                    DutyId: element.DutyID,
                    ShiftId: element.ShiftID,
                    VendorId: this.Filter.IsSubContractor ? element.VendorId : 0,
                  }
                );
              });
              this.employeesitemaping.ESS_EmployeeSiteMapping_InsertUpdate(this.SaveDetails).subscribe({
                next: (response) => {
                  if (response.Error_Code == '784') {
                    this.SaveDetails.SiteId = this.Filter.SiteID;
                    this.SaveDetails.ESS_EmployeeSiteMapping = [];

                    const modalRef = this.modalService.open(AlertSuccessComponent, {
                      size: 'md',
                      backdrop: 'static',
                      centered: true,
                      windowClass: 'confirmation-modal'
                    });
                    modalRef.componentInstance.Message = response.Error_Message;
                    modalRef.result.then((result: any) => {
                      this.IsReset = false;
                      this.Employees = [];
                      this.initializeDataTable('#employeedata', Object.values(this.Employees));
                    });
                  } else {
                    const modalRef = this.modalService.open(AlertWarningComponent, {
                      size: 'md',
                      backdrop: 'static',
                      centered: true,
                      windowClass: 'confirmation-modal'
                    });
                    modalRef.componentInstance.Message = response.Error_Message;
                    modalRef.result.then((result: any) => {
                      if (response.Error_Code == '767') { }
                    });
                  }
                  this.isDisabled = false;
                },
                complete: () => { },
                error: (error) => {
                  this.isDisabled = false;
                },
              });
            }
          });
        } else {
          this.toast.show({ message: 'Please select designation, duty, shift for all check employee.', type: toastTypeEnum.danger });
        }
      } else {
        this.toast.show({ message: 'Please check atleast one employee.', type: toastTypeEnum.danger });
      }
    }
  }

  ESS_EmployeeSiteMappingSelect() {
    this.Employees = [];
    this.isDisabled = true;
    this.employeesitemaping.ESS_EmployeeSiteMappingSelect({ 'SelectType': this.Filter.IsSubContractor ? 'SC' : 'S', 'SiteId': this.Filter.SiteID }).subscribe({
      next: (response) => {
        if (response.Table) {
          response.Table.forEach((element: any) => {
            if (this.Filter.IsSubContractor) {
              this.Employees.push({
                EmployeeDesignationDutyMappingId: element.EmployeeDesignationDutyMappingId,
                EmployeeID: element.EmpMasterID,
                EmpCode: element.EmpCode,
                FullName: element.EmpName,
                Photo: element.Photo,
                IsChecked: false,
                DesignationID: element.DesignationMasterID,
                DutyID: element.DutyMasterID,
                ShiftID: element.ShiftMasterID,
                Dutys: [],
                Shifts: [],
                VendorId: element.VendorId,
                VendorCode: element.VendorCode,
                VendorName: element.VendorName,
              });
            } else {
              this.Employees.push({
                EmployeeDesignationDutyMappingId: element.EmployeeDesignationDutyMappingId,
                EmployeeID: element.EmpMasterID,
                EmpCode: element.EmpCode,
                FullName: element.EmpName,
                Photo: element.Photo,
                IsChecked: false,
                DesignationID: element.DesignationMasterID,
                DutyID: element.DutyMasterID,
                ShiftID: element.ShiftMasterID,
                Dutys: [],
                Shifts: [],
              });
            }
          });
        }

        this.loadAllDropdown();
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async loadAllDropdown() {
    for (let i = 0; i < this.Employees.length; i++) {
      try {
        await this.ComboLoad("Duty", i, false, false);
        await this.ComboLoad("ShiftLoadBasedOnDesignationDuty", i, false, false);
      } catch (err) {
        console.error('Error loading shift for row', i, err);
      }
    }
    this.initializeDataTable('#employeedata', Object.values(this.Employees));
  }

  Reset() {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to reset?';
    modalRef.result.then(result => {
      if (result) {
        this.IsReset = false;
        this.Employees = [];
        this.initializeDataTable('#employeedata', Object.values(this.Employees));
      }
    });
  }
}
